import { Whale } from 'store/reporting/benchmark/types'

export function filterBenchmarkWhales(whales: Whale[] | null, targetName: string, threshold: number): Whale[] | null {
  if (!whales) return null

  return whales.filter(w => {
    if (w.dn === targetName) return true
    return w.ci >= threshold
  })
}
